
import { ReactNode } from 'react';

interface ServiceCardProps {
  title: string;
  description: string;
  link?: string;
  imageUrl?: string;
  icon?: ReactNode;
  iconClass?: string;
}

export const ServiceCard = ({ 
  title, 
  description, 
  link,
  imageUrl,
  icon,
  iconClass
}: ServiceCardProps) => {
  return (
    <div className="service-card hover-lift group p-6 border border-dental-light/20 rounded-xl relative">  
      {(imageUrl || icon) && (
        <div className="w-14 h-14 rounded-full bg-dental-accent/10 flex items-center justify-center mb-5">
          {icon ? (
            <span className={iconClass || 'text-dental-highlight'}>{icon}</span>
          ) : imageUrl ? (
            <img src={imageUrl} alt={title} className={`${iconClass || 'w-8 h-8'}`} />
          ) : null}
        </div>
      )}    
      <h3 className="text-xl font-serif font-medium mb-3 leading-tight">{title}</h3>
      <p className="text-dental-muted mb-4">{description}</p>
      {link && (
        <a
          href={link}
          className="inline-flex items-center text-dental-highlight hover:underline font-medium"
        >
          Learn more
          <svg
            className="ml-2 w-4 h-4 transition-transform duration-300 group-hover:translate-x-1"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M14 5l7 7m0 0l-7 7m7-7H3"
            ></path>
          </svg>
        </a>
      )}
    </div>
  );
};
